import { Box } from "@mui/material"
import {
  MRT_ColumnDef,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"

import { defaultTableProps } from "./config"
import { useSelector } from "react-redux"
import { useEffect } from "react"

type PayrollTableProps = {
  columns: any
  data: any
}

const PayrollTable = ({ columns, data }: PayrollTableProps) => {
  const table = useMaterialReactTable({
    // Essential & default Props

    ...defaultTableProps,
    columns: columns,
    data: data,

    //? Extra Props

    //? Overridden Default Props

    //? Table Action Methods

    //? Table State

    state: {
      //   isLoading: loading,
      columnVisibility: { Actions: true },
      columnPinning: {
        left: ["provider_name"],
        //   right: ["mrt-row-actions"],
      },
    },

    //? Overridden default styling

    //? Component Styling
  })

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <MaterialReactTable table={table} />
    </Box>
  )
}

export default PayrollTable
